<template>
  <div class="c-head--sticky" :class="{ 'c-head--vivid': isMobileMenuExpanded || isVivid }" v-scroll="handleScrollThrottled">
    <slot></slot>
  </div>
</template>
<script lang="ts">
import throttle from 'lodash/throttle';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');

@Component
export default class MainHeader extends BaseComponent {
  @ui.State('mobileMenuToggled') protected readonly isMobileMenuExpanded: boolean;

  protected INTERSECTIONS: string[] = ['.c-hero'];

  protected isVivid: boolean = false;

  protected ranges: number[][] = [];

  protected handleScrollThrottled = throttle(this.onScroll, 250, { leading: false });

  protected beforeMount(): void {
    this.isVivid = !this.INTERSECTIONS.filter(s => document.querySelector(s)).length;
  }

  protected mounted(): void {
    const observed: HTMLElement[] = this.INTERSECTIONS.map((s) => document.querySelector(s) as any).filter((v) => v);
    const top = window.scrollY - this.$el.getBoundingClientRect().y;
    this.ranges = observed.map((el) => el.getBoundingClientRect()).map(({ y, height }) => [top + y - height * .05, top + y + height * .1]);
  }

  protected onScroll(): void {
    if (this.ranges.length) {
      this.isVivid = !this.ranges.some(([from, to]) => window.scrollY >= from && window.scrollY <= to);
    }
  }
}
</script>
